module.exports = __webpack_public_path__ + "static/___002___A-choice-of-standard-and-deluxe-townhomes-and-villas.47096cb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slider/___002___A-choice-of-standard-and-deluxe-townhomes-and-villas.jpg
// module id = 1278
// module chunks = 64098118039141